// * Remove class from DOM element.  IE9 safe.
export const hasClass = (el, cls) => {
  try {
    // * Throw errors unless required elements are provided.
    if (!el) throw Error('!!! ERROR (DOM.fns.classList.has): Unable to validate class.  No element provided.', el)
    if (!cls) throw Error('!!! ERROR (DOM.fns.classList.has): Unable to validate class.  No class provided.', el)

    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1
  } catch (error) {
    MK.captureException && MK.captureException(error)
    return null
  }
}